import { Grid, Typography } from "@mui/material";
import ContentTitle from "../../../components/Content/ContentTitle";
import { useLanguageContext } from "../../../contexts/LanguageContext";
import { useUserContext } from "../../../contexts/UserContext";
import DefaultConstants from "../../../data/Constants";
import { useEffect, useState } from "react";
import IPermission from "../../../interfaces/IPermission";
import FormHelper from "../../../helpers/FormHelper";
import UserService from "../../../services/UserService";
import NavigationHelper from "../../../helpers/NavigationHelper";
import { useNavigationContext } from "../../../contexts/NavigationContext";
import { IMuiIcon } from "../../../interfaces/IMaterial";
import NavigationData from '../../../data/Navigation';
import { useEnvironmentContext } from '../../../contexts/EnvironmentContext';
import IPartnerPms from '../../../interfaces/IPartnerPms';
import DataCard from "../../../components/DataCard";


const Start = () => {
    const { environment } = useEnvironmentContext();
    const { user, enterprise, userPermissions } = useUserContext();
    const { translate } = useLanguageContext();
    const { setSelectedNavigationLink } = useNavigationContext();

    const [recentAccess, setRecentAccess] = useState<IPermission[]>([]);

    useEffect(() => {
        if (enterprise !== undefined) {
            const formData = FormHelper.Create(undefined);
        
            UserService.ListRecentAccess(formData)
                .then((resp) => {
                    setRecentAccess(resp.data.recentAccess as IPermission[]);
                });
        }

        // eslint-disable-next-line
    }, [enterprise]);
    
    
    return (
        <>
            <Grid item xs={12} className='grid-header'>
                <Grid item className='grid-title'>
                    <ContentTitle 
                        name={translate('welcome')} 
                        description={user?.fullName}
                        applyTranslation={false}
                    />
                </Grid>
            </Grid>

            <Grid container 
                className='grid-content overflow-enabled justifycontent-flexstart aligncontent-flexstart' 
                rowSpacing={DefaultConstants.gridRowSpacing} 
                columnSpacing={DefaultConstants.gridColumnSpacing}
            >
                {
                    recentAccess.length > 0 && <>
                        <Grid item xs={12}>
                            <Typography variant='subtitle1' className='grid-content-section-title'>
                                {translate('recentlyAccessed')}
                            </Typography>
                        </Grid>

                        {
                            recentAccess
                                .map(p => NavigationHelper.FilterItems(n => userPermissions.includes(p.alias) && n.alias.includes(p.alias))[0] ?? undefined)
                                .filter(n => n !== undefined)
                                .map(navLink => {
                                    const navCategory = NavigationData.find(n => n.alias.includes(navLink.alias[0]));

                                    return (
                                        <Grid item lg={2.4} md={4} sm={6} xs={12} key={navLink.name}>
                                            <DataCard
                                                variant="default"
                                                variantProps={{
                                                    default: {
                                                        category: navCategory ? environment.partnerPms[navCategory.title as keyof(IPartnerPms)].toString() : undefined,
                                                        title: translate(navLink.name)
                                                    }
                                                }}
                                                Icon={navLink.Icon as IMuiIcon}
                                                onClick={() => setSelectedNavigationLink(navLink)}
                                            />
                                        </Grid>
                                    );
                            })
                        }
                    </>
                }
            </Grid>
        </>
    );
}

export default Start;